(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card-desktop.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card-desktop.js');
"use strict";


const {
  CardImage,
  InfoItem,
  HostFlerp,
  JackpotRibbon
} = svs.bingo_react.components.bingoCard;
const {
  ReactBadge: Badge
} = svs.ui;
const startBingoGame = svs.bingo_react.components.startBingoGame;
const BingoCardDesktop = _ref => {
  let {
    className = '',
    promoPosition,
    gameData: {
      id: gameId,
      badgeText,
      host,
      jackpotAmount,
      startTime,
      subTitle,
      price,
      players,
      title,
      status,
      playMode
    },
    lastWinTimestamp
  } = _ref;
  const classList = ['bingo-card-desktop'];
  classList.push(className);
  const ariaLabel = "Starta spel: ".concat(title, ". ").concat(jackpotAmount ? "Jackpot: ".concat(jackpotAmount, " kr") : '');
  return React.createElement("div", {
    "aria-label": ariaLabel,
    className: classList.join(' '),
    "data-area-name": promoPosition,
    "data-impression": "true",
    "data-impression-tracking": "bingo-card-".concat(promoPosition),
    onClick: () => startBingoGame(gameId, promoPosition),
    onKeyDown: e => e.key === 'Enter' && startBingoGame(gameId),
    role: "button",
    tabIndex: 0
  }, host && React.createElement(HostFlerp, {
    hostName: host.name
  }), jackpotAmount && React.createElement(JackpotRibbon, {
    jackpotAmount: jackpotAmount
  }), React.createElement("div", {
    className: "bingo-card-desktop__image-container"
  }, React.createElement(CardImage, {
    gameId: gameId,
    lastWinTimestamp: lastWinTimestamp,
    showTimer: playMode !== 'SINGLEUSER',
    startTime: startTime,
    status: status
  })), React.createElement("div", {
    className: "bingo-card-desktop-info"
  }, React.createElement("div", {
    className: "bingo-card-desktop-info-title"
  }, React.createElement("h3", {
    className: "bingo-card-desktop-info-title__title"
  }, title, badgeText && React.createElement(Badge, {
    branding: "red",
    className: "bingo-card-desktop-info-title__badge"
  }, badgeText)), React.createElement("h4", {
    className: "bingo-card-desktop-info-title__subtitle"
  }, subTitle)), React.createElement("div", {
    className: "bingo-card-desktop-info__info"
  }, React.createElement(InfoItem, {
    bold: true,
    icon: "".concat(playMode === 'SINGLEUSER' ? 'user' : 'players'),
    label: "".concat(playMode === 'SINGLEUSER' ? '' : "".concat(players, " st"))
  }), React.createElement(InfoItem, {
    bold: true,
    icon: "money",
    label: "".concat(price, " kr")
  }))));
};
setGlobal('svs.bingo_react.components.bingoCard.BingoCardDesktop', BingoCardDesktop);

 })(window);